import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NkTimeEdit } from './time-edit';

const NK_DIRECTIVES: Type<any>[] = [NkTimeEdit];
const modules: Type<any>[] = [
  MatInputModule,
  MatFormFieldModule,
  CommonModule,
  MatButtonModule,
  FormsModule,
  ReactiveFormsModule
];

@NgModule({
  imports: [...modules],
  declarations: [...NK_DIRECTIVES],
  exports: [...modules, ...NK_DIRECTIVES]
})
export class NkTimeEditModule {}
